import { LocationDescriptorObject } from 'history'

const getCardLink = (cardId: number, location, cardMatch, state?: object) => {
  const to: LocationDescriptorObject<object | undefined> = {
    pathname: `/card/${cardId}`
  }

  to.state = {
    ...location.state,
    ...(state || {}),
    fromLocation: location.state?.fromLocation || location
  }

  if (cardMatch?.params.cardId && Number(cardMatch?.params.cardId) !== cardId) {
    to.state = {
      ...to.state,
      cards: [
        ...(location.state?.cards || []),
        {
          id: Number(cardMatch?.params.cardId),
          locationKey: location.key,
        },
      ]
    }
  }

  return {
    to,
    replace: Number(cardMatch?.params.cardId) === cardId
  }
}

export default getCardLink